// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__XUdWB","text":"SelectPayment_text__D4ZbU","title":"SelectPayment_title__3jwFl","btn":"SelectPayment_btn__2cDct"};